module.exports = __webpack_public_path__ + "static/icons/extra-mis-seguros.c6216d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insurances/extra-mis-seguros.svg
// module id = E6rq
// module chunks = 1